import { columnTypeList } from '@common-components/tasks/columns-cells/column-cell-defs';
import { Stack } from '@mui/system';
import { getSelectedBoardId } from '@common-reducers/BoardsSelectors';
import { DBFormThunks, formSelectByQuery } from "@common-reducers/DBServiceThunks";
import { useAppDispatch, useAppSelector } from '@common-reducers/hooks/store.hook';
import { useRef } from 'react';
import BTCheckboxList from '../checkbox-list/bt-checkbox-list';
import { getDynamicColumnListForBTCheckbox } from '@common-reducers/TaskSelectors';
import { TaskColumn } from '@common-models/task-column';

export default function FormsIncludedColumnsDialog() {
    const boardId = useAppSelector(getSelectedBoardId)
    const columnList = useAppSelector((state) => getDynamicColumnListForBTCheckbox(state, 'form'))
        .filter(column => {
            const cell = columnTypeList.find(columnType => columnType.type === column.type)
            return cell?.isCellInForms
        });
    const formsList = useAppSelector((state) => formSelectByQuery(state.DBFormReducer, { boardId: boardId }));
    const form = formsList.length > 0 ? formsList[0] : undefined;
    const dispatch = useAppDispatch()
    const formColumnPickerRef = useRef<HTMLDivElement>(null)

    type ColumnDataEntry = import('@common-models/form').ColumnDataAttributes;
    const columnData: Record<string, ColumnDataEntry> = (form?.columnData ?? {}) as Record<string, ColumnDataEntry>;

    const isChecked = (column: TaskColumn) => {
        const colKey = column._id ?? '';
        const entry = columnData[colKey];
        if (entry === undefined || entry.visible) {
            return true;
        }
        else {
            return false;
        }
    };

    function handleAllCheckBoxChange(value: boolean) {
        let newColumnData: Record<string, ColumnDataEntry> = {}
        for (let i = 0; i < columnList.length; i++) {
            const colKey = columnList[i]._id ?? '';
            newColumnData = {
                ...newColumnData,
                [colKey]: {
                    ...columnData[colKey],
                    visible: value,
                }
            }
        }
        dispatch(DBFormThunks.patch({
            entity: {
                ...form,
                columnData: newColumnData
            }
        }))
    }

    const handleCheckBoxChange = (value: boolean, column: TaskColumn) => {
        const colKey = column._id ?? '';
        dispatch(DBFormThunks.patch({
            entity: {
                ...form,
                columnData: {
                    ...columnData,
                    [colKey]: {
                        ...columnData[colKey],
                        visible: value,
                    }
                }
            }
        }))
    }

    const isCheckedRecord: Record<string, boolean> = columnList.reduce<Record<string, boolean>>((isCheckedRecord, column) => ({
        ...isCheckedRecord,
        [column._id ?? '']: isChecked(column)
    }), {});


    return (
        <Stack ref={formColumnPickerRef} direction="column" style={{
            position: 'relative',
        }}>
            <BTCheckboxList
                isCheckedRecord={isCheckedRecord}
                columnList={columnList}
                handleCheckBoxChange={handleCheckBoxChange}
                handleAllCheckBoxChange={handleAllCheckBoxChange}
            />
        </Stack>
    )
}
